import css from 'styled-jsx/css';

const staticStyles = css.global`
  @import 'src/common/styling/_mixins-scss/screen-size';
  @import 'src/common/styling/_mixins-scss/rem';
`;

const getDynamicStyles = ({ colors, border }) => {
  return css.global``;
};

export { staticStyles, getDynamicStyles };
